// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3ofhY","emails":"CreateEditClinics_emails__1qfLz","emailTagLabel":"CreateEditClinics_emailTagLabel__INRDK"};